// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2q8fU","alert":"SettungsInbox_alert__vOPWW"};